'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _React$cloneElement = require('react');

var _React$cloneElement2 = _interopRequireDefault(_React$cloneElement);

var _BootstrapMixin = require('./BootstrapMixin');

var _BootstrapMixin2 = _interopRequireDefault(_BootstrapMixin);

var _classNames = require('classnames');

var _classNames2 = _interopRequireDefault(_classNames);

var ListGroupItem = _React$cloneElement2['default'].createClass({
  displayName: 'ListGroupItem',

  mixins: [_BootstrapMixin2['default']],

  propTypes: {
    bsStyle: _React$cloneElement2['default'].PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
    className: _React$cloneElement2['default'].PropTypes.string,
    active: _React$cloneElement2['default'].PropTypes.any,
    disabled: _React$cloneElement2['default'].PropTypes.any,
    header: _React$cloneElement2['default'].PropTypes.node,
    listItem: _React$cloneElement2['default'].PropTypes.bool,
    onClick: _React$cloneElement2['default'].PropTypes.func,
    eventKey: _React$cloneElement2['default'].PropTypes.any,
    href: _React$cloneElement2['default'].PropTypes.string,
    target: _React$cloneElement2['default'].PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bsClass: 'list-group-item'
    };
  },

  render: function render() {
    var classes = this.getBsClassSet();

    classes.active = this.props.active;
    classes.disabled = this.props.disabled;

    if (this.props.href || this.props.onClick) {
      return this.renderAnchor(classes);
    } else if (this.props.listItem) {
      return this.renderLi(classes);
    } else {
      return this.renderSpan(classes);
    }
  },

  renderLi: function renderLi(classes) {
    return _React$cloneElement2['default'].createElement(
      'li',
      _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes) }),
      this.props.header ? this.renderStructuredContent() : this.props.children
    );
  },

  renderAnchor: function renderAnchor(classes) {
    return _React$cloneElement2['default'].createElement(
      'a',
      _extends({}, this.props, {
        className: _classNames2['default'](this.props.className, classes)
      }),
      this.props.header ? this.renderStructuredContent() : this.props.children
    );
  },

  renderSpan: function renderSpan(classes) {
    return _React$cloneElement2['default'].createElement(
      'span',
      _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes) }),
      this.props.header ? this.renderStructuredContent() : this.props.children
    );
  },

  renderStructuredContent: function renderStructuredContent() {
    var header = undefined;
    if (_React$cloneElement2['default'].isValidElement(this.props.header)) {
      header = _React$cloneElement.cloneElement(this.props.header, {
        key: 'header',
        className: _classNames2['default'](this.props.header.props.className, 'list-group-item-heading')
      });
    } else {
      header = _React$cloneElement2['default'].createElement(
        'h4',
        { key: 'header', className: 'list-group-item-heading' },
        this.props.header
      );
    }

    var content = _React$cloneElement2['default'].createElement(
      'p',
      { key: 'content', className: 'list-group-item-text' },
      this.props.children
    );

    return [header, content];
  }
});

exports['default'] = ListGroupItem;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/ListGroupItem.js
 ** module id = 224
 ** module chunks = 0
 **/